var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 256
  }), /*#__PURE__*/React.createElement("rect", {
    y: 256,
    style: {
      fill: "#464655"
    },
    width: 512,
    height: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M225.327,143.5l9.212,27.621l29.116,0.226c2.256,0.017,3.191,2.896,1.376,4.236l-23.423,17.297   l8.783,27.761c0.68,2.151-1.768,3.93-3.604,2.618L223.1,206.327l-23.688,16.931c-1.835,1.312-4.284-0.467-3.604-2.618l8.783-27.761   l-23.423-17.297c-1.815-1.34-0.879-4.219,1.376-4.236l29.116-0.226l9.212-27.621C221.587,141.36,224.613,141.36,225.327,143.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M349.85,378.019c0,0-166.683-125.745-171.604-129.879c-7.605-6.388-13.473-17.685-13.755-31.439   c0,0-17.976,18.414-14.456,37.474c4.07,22.035,16.701,29.895,32.982,40.562c11.442,7.496,102.397,64.861,155.493,98.324   L349.85,378.019z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M399.72,414.877c-2.173-1.552-19.629-14.454-43.851-32.399l-8.79,15.983   c17.783,11.206,29.623,18.662,29.623,18.662s1.684,21.895,19.368,18.246C402.447,434.053,407.579,420.491,399.72,414.877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M255.791,356.818c-12.6,4.435-26.095,6.971-40.211,6.971c-35.779,0-67.836-15.588-90.032-40.234   l-19.733,17.759c6.613,7.345,13.675,14.266,21.635,20.174l-3.929,6.805l29.171,16.842l3.862-6.69   c13.179,5.732,27.345,9.588,42.184,11.269v7.759h33.684v-7.759c14.839-1.681,29.005-5.537,42.184-11.269l3.862,6.69l11.593-6.693   C278.74,371.303,267.143,363.985,255.791,356.818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M362.768,225.684c-1.681-14.839-5.537-29.005-11.269-42.183l6.69-3.863l-16.842-29.172l-6.805,3.929   c-8.712-11.739-19.092-22.119-30.832-30.831l3.929-6.805l-29.171-16.842l-3.863,6.69c-10.932-4.755-22.572-8.132-34.683-10.134   l-4.427,26.563c57.475,9.519,101.348,59.317,101.348,119.49c0,32.401-12.786,61.762-33.49,83.516   c7.162,5.408,14.271,10.775,21.297,16.079c3.405-3.727,6.874-7.399,9.892-11.465l6.805,3.929l16.842-29.171l-6.69-3.863   c5.732-13.178,9.588-27.345,11.269-42.183h7.759v-33.684L362.768,225.684L362.768,225.684z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAo);
export default __webpack_public_path__ + "static/media/ao.31267ccef8b63f606bc39bdb89d7ac56.svg";
export { ForwardRef as ReactComponent };